import { render, staticRenderFns } from "./creatRule.vue?vue&type=template&id=143fc9ac&scoped=true&"
import script from "./creatRule.vue?vue&type=script&lang=js&"
export * from "./creatRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143fc9ac",
  null
  
)

export default component.exports